export default {
  add: 'tRecordAdd',
  remove: 'tRecordRemove'
}
